export class EnhancementDoc {
    private documentType: string;
    private documentDescription: string;
    private url: string;
    private file: String;
    private extension: String;
    private canDelete: Boolean;

    constructor(enhancementDoc: any) {
        this.file = enhancementDoc.file;
        this.extension = enhancementDoc.extension;
        this.canDelete = enhancementDoc.canDelete;
        this.documentDescription = enhancementDoc.documentDescription;
        this.documentType = enhancementDoc.documentType;
        this.url = enhancementDoc.url;
    }

    /**
     * Getter $file
     * @return {String}
     */
    public get $file(): String {
        return this.file;
    }

    /**
     * Getter $extension
     * @return {String}
     */
    public get $extension(): String {
        return this.extension;
    }

    /**
     * Getter $canDelete
     * @return {Boolean}
     */
    public get $canDelete(): Boolean {
        return this.canDelete;
    }

    /**
     * Setter $file
     * @param {String} value
     */
    public set $file(value: String) {
        this.file = value;
    }

    /**
     * Setter $extension
     * @param {String} value
     */
    public set $extension(value: String) {
        this.extension = value;
    }

    /**
     * Setter $canDelete
     * @param {Boolean} value
     */
    public set $canDelete(value: Boolean) {
        this.canDelete = value;
    }

    /**
     * Getter $documentType
     * @return {string}
     */
    public get $documentType(): string {
        return this.documentType;
    }

    /**
     * Getter $documentDescription
     * @return {string}
     */
    public get $documentDescription(): string {
        return this.documentDescription;
    }

    /**
     * Getter $url
     * @return {string}
     */
    public get $url(): string {
        return this.url;
    }

    /**
     * Setter $documentType
     * @param {string} value
     */
    public set $documentType(value: string) {
        this.documentType = value;
    }

    /**
     * Setter $documentDescription
     * @param {string} value
     */
    public set $documentDescription(value: string) {
        this.documentDescription = value;
    }

    /**
     * Setter $url
     * @param {string} value
     */
    public set $url(value: string) {
        this.url = value;
    }

}
